import type { IconProps } from "../types";

export const LayoutTemplate = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <rect width="18" height="7" x="3" y="3" />
    <rect width="9" height="7" x="3" y="14" />
    <rect width="5" height="7" x="16" y="14" />
  </svg>
);
